import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const currencies = sqliteTable('currencies', {
  id: integer('id').primaryKey({ autoIncrement: true }),
  name: text('name').notNull(),
  iso_code: text('iso_code').notNull(),
  iso_code_num: text('iso_code_num').notNull().default('0'),
  symbol: text('symbol').notNull(),
  exchange_rate: real('exchange_rate').notNull(),
  status: integer('status', { mode: 'boolean' }).notNull().default(true),
  is_default: integer('is_default', { mode: 'boolean' }).notNull().default(false),
  sort: integer('sort'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
  deleted_at: text('deleted_at'),
});
